import { CACHEOR_KEYS } from "@/constants/cacheor";
import { getQingzhouConfig, getSeoInlinks } from "@/services";
import { getV3Config } from "@/services/global";
import { cacheor } from "@/utils/server/cacheor";
const footerCacheorKey = CACHEOR_KEYS.FOOTER_CONFIG;
const appInfoCacheorKey = CACHEOR_KEYS.APP_INFO;

async function getFooterQZConf(query: { _cache?: boolean }) {
  const cacheData = await cacheor.get({ key: footerCacheorKey });
  if (cacheData?.pits && !query?._cache) {
    return cacheData;
  }
  const result = await getQingzhouConfig({
    position: "framework-footer-huaban",
  });
  // 缓存数据
  cacheor.set({ key: footerCacheorKey, value: result, ttl: 60 * 60 });
  return result;
}

async function getAppInfo(query: { _cache?: boolean }) {
  const cacheData = await cacheor.get({ key: appInfoCacheorKey });
  if (cacheData?.apps && !query?._cache) {
    return cacheData;
  }
  const result = await getV3Config();
  // 缓存数据
  cacheor.set({ key: appInfoCacheorKey, value: result, ttl: 60 * 60 });
  return result;
}

export default async function getDataSource(options: {
  query: { _cache?: boolean };
  seoLinkInfo: { currentUrl: string };
}) {
  const [footerConf, inlinks, appInfo] = await Promise.all([
    getFooterQZConf(options.query),
    getSeoInlinks({
      title: undefined,
      current_url: options.seoLinkInfo.currentUrl,
    }),
    getAppInfo(options.query),
  ]);

  return {
    pits: footerConf?.pits,
    internalLinks: inlinks,
    appReleases: appInfo?.apps,
  };
}
